<template>
  <div class="role" v-loading="loading">
    <div class="role-first">
      <div class="role-first-addition" @click="additionBtn">
        <img class="addition-img" src="../../assets/common/common-add.png" />
        <div class="addition-text">添加</div>
      </div>
    </div>

    <div class="role-second">
      <div class="role-second-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column prop="id" label="id"> </el-table-column>
          <el-table-column prop="userName" label="id名称"> </el-table-column>
          <el-table-column prop="phone" label="手机号码"> </el-table-column>
          <el-table-column prop="positionDesc" label="职位描述" width="460">
          </el-table-column>
          <el-table-column prop="createTime" label="加入时间">
          </el-table-column>
          <el-table-column prop="id" label="操作">
            <template slot-scope="scope">
              <div class="table-operation">
                <div class="table-operation-left" @click="editRole(scope.row)">
                  编辑
                </div>
                <div
                  class="table-operation-right"
                  @click="deteleRole(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="role-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 删除权限用户 -->
    <div class="undercarriage">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="deteleReset"
      >
        <span slot="footer" class="dialog-footer">
          <div class="undercarriage-div">
            <img
              class="undercarriage-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="undercarriage-div-title">是否删除该管理人员？</div>

            <div class="undercarriage-div-text">
              一旦删除。则该管理id不可登录后台。
            </div>
            <div class="undercarriage-div-button">
              <div class="undercarriage-div-button-left" @click="deteleConfirm">
                确定
              </div>
              <div class="undercarriage-div-button-right" @click="deteleReset">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'

import { getAdminList, deletefnAdminList } from '../../api/role'

export default {
  data() {
    return {
      // 第二区域 表格
      tableData: [],
      // 表格总数
      totalNum: 0,
      // 第二区域 点击删除 开启弹出框
      deteleDialogVisible: false,
      // 监听用户刷新
      loading: false,
      // 表格页数
      page: 1,
      // 表格每页条数
      limit: 11,
      // 获取当前列表的id
      managementId: '',
      // 控制当前页面功能性按钮开关
      roleFunShow: true,
    }
  },
  created() {
    // 获取管理员列表

    this.loading = true
    this.getAdminClick()
  },
  methods: {
    // 获取管理员列表
    getAdminClick() {
      let params = {
        phone: '', // 手机号
        userName: '', // 用户名 id名称
        nickname: '', // 昵称
        position: '', // 职位
        status: '', // 状态 1启用
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getAdminList(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.adminList
          // 获取表格总数
          this.totalNum = res.resultData.totalNum

          this.loading = false
        }
      })
    },
    // 点击添加 跳转 添加角色权限页面
    additionBtn() {
      if (this.roleFunShow == false) {
        return
      }

      Bus.$emit('log', 'roleAdd')
    },
    // 第二区域表格区域 编辑
    editRole(item) {
      if (this.roleFunShow == false) {
        return
      }

      Bus.$emit('log', 'roleAdd', item)
    },
    // 第二区域表格区域 删除
    deteleRole(item) {
      if (this.roleFunShow == false) {
        return
      }

      this.managementId = item.id
      this.deteleDialogVisible = true
    },
    // 第二区域 删除弹出框 确定
    deteleConfirm() {
      let params = this.managementId

      deletefnAdminList(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
            duration: 2000,
          })

          this.loading = true
          this.deteleDialogVisible = false
          this.getAdminClick()
        }
      })
    },
    // 第二区域 删除弹出框 取消
    deteleReset() {
      this.managementId = ''
      this.deteleDialogVisible = false
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getAdminClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getAdminClick()
    },
  },
}
</script>

<style lang="less" scoped>
.role {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;

  .role-first {
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;

    .role-first-addition {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 82px;
      height: 36px;
      background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
      border-radius: 10px;
      cursor: pointer;

      .addition-img {
        width: 13px;
        height: 13px;
        margin-right: 8px;
      }

      .addition-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .role-second {
    .role-second-table {
      padding: 0 24px;
      box-sizing: border-box;
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-operation {
        display: flex;

        .table-operation-left,
        .table-operation-right {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .table-operation-right {
          margin-left: 24px;
        }
      }
    }

    .role-second-Pagination {
      height: 80px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  // 商品上下架
  .undercarriage {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .undercarriage-div {
      width: 100%;
      text-align: center;
      .undercarriage-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .undercarriage-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 8px;
      }

      .undercarriage-div-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 2px;
      }

      .undercarriage-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .undercarriage-div-button-left,
        .undercarriage-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .undercarriage-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
